<template>
  <div class="footer">
    <div :class="{ 'alert-box': true, 'show-box': flag, 'alert-box1': isShow == 0 }" ref="msgBox">
      <div v-show="!flag" :class=" ['short',isShow == 0 ? 'short-hidden' : '' ]">
        <div class="is-show" @click="footerAlertbox">
            <p :class="{'p': isShow == 0 }">{{isShow == 1 ? '收起' : '展开' }}</p>
            <img v-if="isShow === 1" src="../../static/images/right.png" alt="" />
            <img v-else src="../../static/images/left.png" alt="" />
        </div>
        <img
          :class="{ 'show-img': flag }"
          src="../../static/images/zixun1.png"
          alt=""
          class="man"
          v-if="isShow == 1"
        />
        <img src="../../static/images/dianhau.png" class="phone" v-if="isShow == 1"/>
        <p class="phone-text" v-if="isShow == 1">咨询电话</p>
        <p class="phone-num" v-if="isShow == 1">13824289487</p>
        <a class="qq-btn" v-if="isShow == 1">
          <img class="qq" src="../../static/images/wechat.png" />
          <span> 微信咨询</span>
          <div class="qrcode">
            <img src="../../static//images/qrcode.png" alt="">
          </div>
        </a>
        <!-- <a-icon type="qq" style="font-size:20px;color:#3A5FC9" /><a
  target="_blank"
  href="http://wpa.qq.com/msgrd?v=3&uin=1635168736&site=qq&menu=yes"
  class="online_qq dis"
>叶工(138288675xx)</a> -->

      </div>
      <div class="zhiding" @click="zhiding()" v-if="isShow == 1">
        <img src="../../static/images/gotop.png" />
      </div>
    </div>
    <div class="footer-content">
      <div class="left">
        <div class="logo">
          <img :src="bottomData.logo_image" alt="" />
        </div>
        <ul class="info">
          <li>
            <i class="iconfont icon-dingwei"></i
            ><span>地址：广东省广州市天河区荷光路137号三楼</span>
          </li>
          <li>
            <i class="iconfont icon-dingwei"></i
            ><span>地址：惠城区四环南路3号读者文化园 E座1204</span>
          </li>
          <li>
            <i class="iconfont icon-tel-fill"></i
            ><span>联系电话：13824289487</span>
          </li>
          <li>
            <i class="iconfont icon-wangzhan"></i
            ><span>网址：eartisan.wsandos.com</span>
          </li>
        </ul>

        <div class="account">
          <div>
            <img :src="bottomData.public_code" alt="" />
            <h5>微信公众号</h5>
          </div>
          <!-- <div class="account-right">
            <img :src="bottomData.qr_code" alt="" />
            <h5>小程序号</h5>
          </div> -->
        </div>
        <div class="copy">
          <div class="desc">版权所有&nbsp;:&nbsp;惠州市一匠科技有限公司</div>
          <p @click="footBar">ICP证号&nbsp;:&nbsp;粤ICP备14001464号</p>
        </div>
      </div>
      <div class="right">
        <div class="row" v-for="item in footerList" :key="item.id">
          <div class="title" @click="pageUrl(item.URl)">
            {{ item.title }}
          </div>
          <div class="item" v-for="s_item in item.descList"
                :key="s_item.id" @click="pageUrl(s_item.URl)">
                 <!-- @click="jumpPage(s_item.URl, s_item.y)" -->
            {{ s_item.desc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    bottom: Object,
    bottomInfo: Object,
    bottomNews: Array,
    productType: Array,
  },
  data() {
    return {
      flag: false,
      count: 0,
      isShow: window.sessionStorage.getItem('alertShow') || 1,
      footerList: [
        {
          id: 0,
          title: "软件研发",
          URl: '/custom',
          descList: [
            {
              id: 0,
              desc: "物联网&智能软硬定制",
              URl:'/custom',
            },
            {
              id: 1,
              desc: "APP定制",
              URl:'/custom',
            },
            {
              id: 2,
              desc: "Web系统定制",
              URl:'/custom',
            },
            {
              id: 3,
              desc: "微信小程序定制",
              URl:'/custom',
            },
            {
              id: 4,
              desc: "微信公众号定制",
              URl:'/custom',
            },
            {
              id: 5,
              desc: "企业系统定制",
              URl:'/custom',
            },
            {
              id: 6,
              desc: "定制优势",
              URl:'/custom',
            },
          ],
        },
        {
          id: 1,
          title: "解决方案",
          URl: '/solution/live',
          descList: [
            {
              id: 0,
              desc: "电商系统解决方案",
              URl: '/solution/live',
            },
            {
              id: 1,
              desc: "电商行业解决方案",
              URl: '/solution/mother',
            },
            {
              id: 2,
              desc: "电商营销解决方案",
              URl: '/solution/mother',
            },
            {
              id: 3,
              desc: "教育系统解决方案",
              URl: '/solution/live',
            },
            {
              id: 4,
              desc: "智慧行业解决方案",
              URl: '/solution/wisdom',
            },
          ],
        },
        {
          id: 2,
          title: "案例中心",
          URl: '/cases',
          descList: [
            {
              id: 0,
              desc: "物联网&智能软硬",
              URl: '/cases',
            },
            {
              id: 1,
              desc: "Web系统",
              URl: '/cases',
            },
            {
              id: 2,
              desc: "微信小程序",
              URl: '/cases',
            },
            {
              id: 3,
              desc: "微信公众号",
              URl: '/cases',
            },
            {
              id: 4,
              desc: "企业系统",
              URl: '/cases',
            },
          ],
        },
        {
          id: 3,
          title: "服务中心",
          URl: '/service',
          descList: [
            {
              id: 0,
              desc: "服务支持",
              URl: "/service",
              y: '500'
            },
            {
              id: 1,
              desc: "八大增值服务",
              URl: "/service",
            },
          ],
        },
        {
          id: 4,
          title: "关于我们",
          URl: '/about',
          descList: [
            {
              id: 0,
              desc: "一匠简介",
              URl: '/about',
            },
            {
              id: 1,
              desc: "我们的优势",
              URl: '/about',
            },
            {
              id: 2,
              desc: "联系方式",
              URl: '/about',
            },
          ],
        },
        {
          id: 5,
          title: "新闻中心",
          URl: '/news',
          descList: [
            {
              id: 0,
              desc: "新闻中心",
              URl:'/news',
            },
            {
              id: 0,
              desc: "NEWS",
              URl:'/news',
            },
          ]
        },
        {
          id: 6,
          title: "合作加盟",
          URl:'/teamwork',
          descList: [
            {
              id: 0,
              desc: "加盟联系",
              URl:'/teamwork',
            },
          ],
        },
      ],
      bottomData:{}
    };
  },
  watch: {
    productType(newVal) {
      if (!newVal) return;
      // this.headerList[2].dropDown = newVal
      // console.log(newVal[0])
      // this.typeName = newVal[0].name
      this.footerList[3].url = "/product/" + newVal[0].name;
    },
  },
  mounted() { 
    this.getSundry();
  },
  methods: {
    jumpPage(url, y) {
      window.location.href = url;
      // window.scrollTo(0, y);
    },
    footerAlertbox(){
      this.isShow = this.isShow == 1 ? 0 : 1;
      window.sessionStorage.setItem('alertShow',this.isShow);
    },
    getSundry(){
     this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/sundry",
        null,
        (res) => {
          if(res.code==1){
          // console.log(res.data)
          this.bottomData = res.data;
          }
        }
      );
    },
    jumpService() {
      this.$addConsult()
    },
    // 点击跳转外链
    footBar() {
      window.location.href = "http://beian.miit.gov.cn";
    },
    pageUrl(url) {
      this.$router.push(url);
    },
    newsUrl() {
      this.$router.push("/news");
    },
    newsDetail(id) {
      this.$router.push("/newsdetail/" + id);
    },
    show() {
      event.stopPropagation();
      this.flag = !this.flag;
      if (this.flag) {
        setTimeout(() => {
          this.$refs.formDiv.style.display = "inline-block";
          this.$refs.msgBox.removeEventListener("click", show);
        }, 200);
      } else {
        this.$refs.formDiv.style.display = "none";
        this.$refs.msgBox.addEventListener("click", show);
      }
    },
    stop() {
      event.stopPropagation();
    },
    valLength() {
      const needStr = this.$refs.needinput.value;
      // if(this.$refs.phoneinput.value && needStr){
      //     this.$refs.btn.disabled = ""
      // }else{
      //     this.$refs.btn.disabled = "disabled"
      // }
      this.$refs.needinput.value = needStr.replace(/\s{2,}/g, " ");
      this.count = needStr.replace(/\s{1,}/g, "").length;
      if (this.count > 20) {
        this.count = 20;
        this.$refs.needinput.value = needStr.substr(0, needStr.length - 1);
      }
    },
    checkPhone() {
      var phone = this.$refs.phoneinput.value;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.phone = false;
      } else {
        this.phone = true;
      }
    },
    send() {
      event.stopPropagation();
      if (this.$refs.needinput.value.replace(/\s{1,}/g, "") == "") {
        alert("请填写内容！");
        event.preventDefault();
        return false;
      }
      if (this.$refs.needinput.value.replace(/\s{1,}/g, "").length > 20) {
        alert("超出20个字数限制！");
        event.preventDefault();
        this.$refs.needinput.value = "";
        this.count = 0;
        return false;
      }
      if (!this.phone) {
        alert("手机号码有误，请重填");
        event.preventDefault();
        this.$refs.phoneinput.value = "";
        return false;
      }
      alert("提交成功");
      this.count = 0;
      setTimeout(() => {
        this.$refs.needinput.value = "";
        this.$refs.phoneinput.value = "";
      }, 20);
    },
    zhiding() {
      window.scrollTo({top:0, behavior: 'smooth'})
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/mixins.styl';
@import '~styles/varible.styl';
.footer {
  width: 100%;
  color: #fff;
  min-width: 1440px;
  margin: 0 auto;
  background: #000;
  background: url('../../static/images/footer.png');
  position: relative;
  z-index: 8;



  .footer-content {
    display: flex;
    justify-content: center;
    width: 90%;
    margin: 0 auto;
    padding: 48px 0 49px;

    .left {
      .info, .account, .copy {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.45);
      }

      .info {
        margin-top: 52px;

        span {
          padding-left: 12px;
        }

        li {
          margin-bottom: 15px;
          min-width: 266px;
        }
        li:nth-child(2) span {
          line-height: 20px;
        }
      }

      .account {
        display: flex;
        justify-content: space-between;
        margin-top: 32px;

        h5 {
          text-align: center;
          margin-top: 17px;
        }

        .account-right {
          margin-left: 20px;
        }
      }

      .copy .desc {
        margin: 32px 0 15px;
      }
    }

    .right {
      display: flex;
      margin-left: calc(var(--proportion) * 99px);
      transition: all .5s;

      .title {
        width: calc(var(--proportion) * 190px);
        min-width:155px;
        height: 44px;
        // border-bottom: 1px solid rgba(255, 255, 255, 0.45);
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        cursor: pointer;
      }

      .item {
        margin-top: 32px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.45);
        cursor: pointer;
        
        // a {
        //   color: rgba(255, 255, 255, 0.45);
        // }
      }
      .item:hover{
        color: rgba(255, 255, 255, 1);
      }
    }
  }

  .alert-box {
    position: fixed;
    right: 10px;
    top: calc(100% - 580px);
    z-index: 999;
    transition: all 0.3s;
    width: 120px;
    // height: 280px;
    // background: #FFFFFF;
    // box-shadow: 0px 1px 20px 5px rgba(185, 185, 185, 0.2);
    // border-radius: 8px;
    // padding: 20px 0;
    box-sizing: border-box;

    >* {
      vertical-align: text-bottom;
    }

    .short {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background: #FFFFFF;
      box-shadow: 0px 1px 20px 5px rgba(185, 185, 185, 0.2);
      border-radius: 8px;
      padding: 0 0 20px 0;
      transition: all .3s;
    }

    .short-hidden{
      height:50px;
      height:50px;
      border:1px solid #F5F5F5;
      padding:0;
      .is-show{
        margin-bottom: 0;
      }
    }

    .is-show{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 52px;
      font-size: 14px;
      color:#666666;
      cursor: pointer;
      margin-bottom:10px;
      border-bottom: 1px solid #F5F5F5;
      p{
        margin-right:5px;
      }
      .p{
        margin-right:2px;
      }
  }

    .zhiding {
      position: relative;
      width: 120px;
      height: 40px;
      background: #FFFFFF;
      box-shadow: 0px 1px 20px 5px rgba(185, 185, 185, 0.2);
      border-radius: 8px;
      margin-top: 10px;
      cursor: pointer;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width:30px;
        height:26px;
      }
    }

    img.man {
      width: 80px;
    }

    img.phone {
      width: 32px;
      margin-top: 14px;
    }

    img.qq {
      width: 20px;
    }

    .phone-text {
      font-weight: 400;
      color: #333333;
      margin-top: 15px;
    }

    .phone-num {
      font-size: 16px;
      font-family: DINPro;
      font-weight: 900;
      color: #FFC000;
      margin-top: 15px;
    }

    .qq-btn {
      position:relative;
      text-align: center;
      line-height: 32px;
      font-weight: 400;
      color: #333333;
      margin-top: 15px;
      width: 100px;
      height: 32px;
      background: #FFC000;
      border-radius: 4px;
      font-size: 12px;
      cursor: pointer;
      z-index:9;
      &:hover{
        .qrcode{
          display:block;
        }
      }
      .qrcode{
        display:none;
        position:absolute;
        top:0;
        left:-200px;
        width: 200px;
        height:200px;
        img{
          width:100%;
          height:100%;
        }
      }
    }
  }
  .alert-box1{
    overflow: hidden;
    width: 50px;
    border-radius: 8px;
    box-shadow: 0px 1px 20px 5px rgba(185, 185, 185, .4);
  }
}

</style>


// WEBPACK FOOTER //
// src/components/pc/Footer.vue